import {
	SYS_COLOR_SURFACE_NEUTRAL_200_LIGHT,
	SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT,
	SYS_SPACE_FIXED_100,
	SYS_SPACE_FIXED_150,
	SYS_SPACE_FIXED_200,
} from '@oneaudi/unified-web-common';

import styled from 'styled-components';

export const ButtonTabsContainer = styled.div`
	width: 100%;
	display: flex;
	padding: ${SYS_SPACE_FIXED_150} 0;
	margin-bottom: ${SYS_SPACE_FIXED_200};
`;

export const StyledButtonTab = styled.button<{ $isActive: boolean }>`
	width: 100%;
	padding: ${SYS_SPACE_FIXED_100};
	background-color: ${({ $isActive }) =>
		$isActive ? SYS_COLOR_SURFACE_NEUTRAL_200_LIGHT : SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT};
	transition: all 0.3s ease-in-out;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	.label {
		color: ${({ $isActive }) =>
			$isActive ? SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT : SYS_COLOR_SURFACE_NEUTRAL_200_LIGHT};
	}
`;
